module.exports = { "default": require("core-js/library/fn/symbol/to-string-tag"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol/to-string-tag.js
// module id = 1041
// module chunks = 0